// extracted by mini-css-extract-plugin
module.exports = {"root":"FRpKX7H7","disclaimer":"rl-ZqnCQ"};